// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const LockClosed = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps} transform="translate(6, 0)">
            <Path d="M4,16 L4,10.0295557 C4,4.49038506 8.43864822,0 14,0 C19.5228475,0 24,4.49868441 24,10.0295557 L24,16 L27.0034652,16 C27.5538362,16 28,16.4474692 28,17.0006946 L28,38.9993054 C28,39.5519738 27.5601869,40 27.0034652,40 L0.996534824,40 C0.446163838,40 0,39.5525308 0,38.9993054 L0,17.0006946 C0,16.4480262 0.439813137,16 0.996534824,16 L4,16 Z M8,10.0295557 L8,15.9919434 L20,15.9919434 L20,10.0295557 C20,6.70180893 17.3076918,4 14,4 C10.6661284,4 8,6.68113924 8,10.0295557 Z" />
        </G>
    );
};

export default LockClosed;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/lock-closed/index.js